import {
  AdminCreateCustomer,
  AdminFetchCustomer,
  AdminFetchCustomers,
} from 'src/constants/actionTypes'
import type { Customer } from 'src/interfaces/customer'
import { Action } from 'src/utils/reduxUtils'
import { CustomerState } from './types'

function resolveApiErrorMessage(err: unknown, fallback: string): string {
  if (typeof err === 'object' && err !== null) {
    const top = err as { message?: string; payload?: { message?: string } }

    if (typeof top.payload?.message === 'string') {
      return top.payload.message
    }

    if (typeof top.message === 'string') {
      return top.message
    }
  }

  return fallback
}

const getInitialState = (): CustomerState => ({
  customers: [],
  customersLoading: false,
  customersError: null,
  customer: null,
  customerLoading: false,
  customerError: null,
  creating: false,
})

export const customerReducer = (
  state: CustomerState = getInitialState(),
  action: Action<unknown>,
): CustomerState => {
  switch (action.type) {
    case AdminFetchCustomers.type.REQUEST:
      return {
        ...state,
        customersLoading: true,
        customersError: null,
      }
    case AdminFetchCustomers.type.SUCCESS: {
      const customers = (action.payload as Customer[] | undefined) ?? []

      return {
        ...state,
        customers,
        customersLoading: false,
        customersError: null,
      }
    }
    case AdminFetchCustomers.type.FAILED:
      return {
        ...state,
        customersLoading: false,
        customersError: resolveApiErrorMessage(action.payload, 'Failed to load customers'),
      }

    case AdminFetchCustomer.type.REQUEST: {
      const customerId = (action.payload as { customerId?: string } | undefined)?.customerId
      const isSameCustomer = Boolean(customerId) && state.customer?.id === customerId

      return {
        ...state,
        customer: isSameCustomer ? state.customer : null,
        customerLoading: true,
        customerError: null,
      }
    }
    case AdminFetchCustomer.type.SUCCESS:
      return {
        ...state,
        customer: (action.payload as Customer) ?? null,
        customerLoading: false,
        customerError: null,
      }
    case AdminFetchCustomer.type.FAILED:
      return {
        ...state,
        customerLoading: false,
        customerError: resolveApiErrorMessage(action.payload, 'Failed to load customer'),
      }

    case AdminCreateCustomer.type.REQUEST:
      return {
        ...state,
        creating: true,
      }
    case AdminCreateCustomer.type.SUCCESS:
      return {
        ...state,
        creating: false,
      }
    case AdminCreateCustomer.type.FAILED:
      return {
        ...state,
        creating: false,
      }

    default:
      return state
  }
}
